import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Box, CardActions, Collapse, IconButton } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { usePriceService } from '../../../utils/hooks/priceService';
import { getFullName } from '../../../utils';
import { useDateTimeService } from '../../../utils/hooks/dateTimeService';
import { useUser } from '../../../utils/hooks/auth';
import { Typography } from '../../../ui-kit';
import { CashDrawerOperation } from './types';

interface CashDrawerOperationsTableProps {
    cashDrawerOperations: CashDrawerOperation[];
}

const CashDrawerOperationsTable: React.FC<CashDrawerOperationsTableProps> = ({ cashDrawerOperations }) => {
    const { priceService } = usePriceService();
    const { dateTimeService } = useDateTimeService();
    const { user: { cultureCode } } = useUser();
    const { t } = useTranslation();
    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align="left">{t('Performed by')}</TableCell>
                        <TableCell align="center">{t('Amount')}</TableCell>
                        <TableCell align="center">{t('Note')}</TableCell>
                        <TableCell align="right">{t('Performed at')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {cashDrawerOperations.map(({
                        id,
                        amount,
                        createdUtc,
                        note,
                        createdBy,
                    }) => (
                        <TableRow key={id}>
                            <TableCell align="left">{getFullName(createdBy.account)}</TableCell>
                            <TableCell align="center">{priceService.toLocaleString(amount)}</TableCell>
                            <TableCell align="center">{note}</TableCell>
                            <TableCell align="right">{dateTimeService.localizeDateTime(createdUtc, cultureCode)}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

interface CashDrawerOperationsProps {
    cashDrawerOperations: CashDrawerOperation[];
}

const CashDrawerOperations = ({ cashDrawerOperations }: CashDrawerOperationsProps) => {
    const [expanded, setExpanded] = React.useState(false);
    const { t } = useTranslation();

    if (cashDrawerOperations.length === 0) {
        return null;
    }

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };
    return (
        <>
            <CardActions>
                <Box display='flex' px={2} alignItems='center' justifyContent='space-between' flex={1}>
                    <Typography uppercase color='primary'>{t('Cash drawer operations')}</Typography>
                    <IconButton
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        color='primary'
                        aria-label="show more"
                    >
                        <ExpandMoreIcon />
                    </IconButton>
                </Box>
            </CardActions>
            <Collapse in={expanded}>
                <Box mx={4} mb={2}>
                    <CashDrawerOperationsTable cashDrawerOperations={cashDrawerOperations} />
                </Box>
            </Collapse>
        </>
    );
};

export default CashDrawerOperations;
